var map = {
	"./favicon-16x16.png": 23,
	"./favicon-32x32.png": 24,
	"./favicon.ico": 25,
	"./favicon.png": 26
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;



// WEBPACK FOOTER //
// ./src/assets/favicons /^/.//